import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_40 } from '../../Button'
import { FormActions } from '../../Form'
import { useEpostFormContext } from '../Epost.hooks'

import { QA_NAME_EPOST_FORM_ACTIONS_CALCULATE_BUTTON } from './EpostFormActions.constants'

import RecalculateIcon from '../../../icons/restore.svg'

function EpostFormActions() {
  const { t } = useTranslation()

  const {
    calculatingData,
    handleClickSupport,
    isCalculated,
    isCalculating,
    isInitiating,
    readonly,
    validationErrors,
  } = useEpostFormContext()

  const isRecalculate = isCalculated || readonly

  return (
    <FormActions
      ButtonAdd={null}
      ButtonCancel={null}
      ButtonClear={null}
      UploadComponent={null}
      submitProps={{
        ...(isRecalculate
          ? { beforeIconProps: { Icon: RecalculateIcon } }
          : null),
        disabled: readonly,
        height: BUTTON_HEIGHT_40,
        isLight: true,
        isLoading: isCalculating && !readonly,
        isSkeleton: isInitiating,
        qaName: QA_NAME_EPOST_FORM_ACTIONS_CALCULATE_BUTTON,
        title: isRecalculate
          ? 'Epost.RecalculateBtnTextKey'
          : 'Epost.CalculateBtnTextKey',
      }}
    >
      {calculatingData &&
      !calculatingData.isEnoughCredits &&
      validationErrors?.length === 0 &&
      !readonly ? (
        <Button.Outlined
          isLoading={isCalculating}
          text={t('Epost.ContactSupportBtnKey')}
          onClick={handleClickSupport}
        />
      ) : null}
    </FormActions>
  )
}

export default EpostFormActions
